export default class {
    constructor(params) {
        this.setting = Object.assign({}, this.defaults(), params)
        if(!this.setting.mainSelector) return

        this.createContent()
    }
    defaults(){
        return {
            mainSelector: null,
            childrenSelector: '.tab',
            headerTag: 'header',
        }
    }

    createContent(){
        let tabTitles = []
        this.setting.tabContents = document.querySelectorAll(`${this.setting.mainSelector} > ${this.setting.childrenSelector}`)

        document.querySelectorAll(`${this.setting.mainSelector} > ${this.setting.childrenSelector}`).forEach(_obj => {
            tabTitles.push(_obj.querySelector('.title').textContent)
            _obj.style.display = 'none'
        })
        let headerDom = document.createElement(this.setting.headerTag)
        tabTitles.forEach((_obj, idx) => {
            let p = document.createElement('p')
            p.textContent = _obj
            headerDom.appendChild(p)

            p.addEventListener('click', e => {
                let idx = [...e.target.parentNode.children].findIndex(c => c == e.target)
                for(const elm of e.target.parentNode.children){
                    elm.classList.remove('active')
                }
                e.target.classList.add('active')
                this.setting.tabContents.forEach(_obj => { _obj.style.display = 'none' })
                this.setting.tabContents[idx].style.display = 'block'
            })
            if (idx == 0) {
                this.triggerEvent(p, 'click')
            }
        })
        document.querySelector('.tag-area').prepend(headerDom)
        this.setting.headerContents = headerDom
    }
    triggerEvent(element, event) {
        if (document.createEvent) {
            // IE以外
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent(event, true, true); // event type, bubbling, cancelable
            return element.dispatchEvent(evt);
        } else {
            // IE
            var evt = document.createEventObject();
            return element.fireEvent("on" + event, evt)
        }
    }
}
